import { useContext } from 'react'
import { Box, Grid } from '@mui/material'
import MainLayout from '../components/common//layout/MainLayout'
import PromoCards from '../components/dashboard/cards/promoCards'
import Welcome from '../components/dashboard/welcome'
import CustomerDashboard from '../components/dashboard/customer/customerDashboard'
import { DataContext } from '../contexts/data/dataContext'
import { analyticsDomain, analyticsCta } from '../services/constants'
import { sendClickAnalytics } from '../components/common/util/util'

import custom from '../styles/mui/szVariables.json'

export default function Dashboard() {
  const data = useContext(DataContext)

  const handleWelcomeClose = () => {
    sendClickAnalytics('/dashboard', {
        domain: analyticsDomain.dashboard,
        name: analyticsCta.hideWelcomeBanner,
        metadata: {},
      })
    data?.hideWelcome()
  }

  return (
    <MainLayout>
        <Box maxWidth={"100%"} 
            display={data?.displayWelcome?'block': 'none'}
            px={custom.spacing.md}>
            <Welcome handleClose={handleWelcomeClose} />
        </Box>
        <Grid container 
            direction="column" 
            id="dashboardContent" 
            maxWidth={"100%"}
            >    
          <CustomerDashboard />   
          <Grid item xs width="100%" pb={custom.spacing.xl}>
            <PromoCards />
          </Grid>
        </Grid>
    </MainLayout>
  )
}
